/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_Empty_DescriptionInputs */

const en_directory_platforms_empty_description = /** @type {(inputs: Directory_Platforms_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse the full directory while more published products add platform details.`)
};

const zh_directory_platforms_empty_description = /** @type {(inputs: Directory_Platforms_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多已发布产品正在补充平台信息，你也可以先浏览完整目录。`)
};

/**
* | output |
* | --- |
* | "Browse the full directory while more published products add platform details." |
*
* @param {Directory_Platforms_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_empty_description = /** @type {((inputs?: Directory_Platforms_Empty_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Empty_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_empty_description(inputs)
	return zh_directory_platforms_empty_description(inputs)
});
export { directory_platforms_empty_description as "directory.platforms.empty_description" }